import {
  Grid,
  Typography,
  Divider,
  Box,
  Chip,
  Paper,
  Button,
  TablePagination,
  Alert,
  Backdrop,
  CircularProgress,
  Tooltip,
  IconButton,
  TextField,
  Autocomplete,
  createFilterOptions,
} from "@mui/material";
import { useIntl } from "react-intl";
import { useEffect, useMemo, useState } from "react";
import { Spinner } from "react-bootstrap";
import env from "react-dotenv";
import {
  IconReportSearch,
  IconShoppingCartCopy,
  IconCopyPlusFilled,
  IconCoffee,
  IconThumbDown,
  IconCancel,
  IconCheckupList,
  IconEdit,
  IconTruckDelivery,
  IconPackageExport,
  IconMessage,
  IconCheck,
  IconX,
  IconPencil,
  IconFileInvoice,
} from "@tabler/icons-react";
import ModalConfirm from "components/ModalConfirm/ModalConfirm";
import { IconBrandAuth0 } from "@tabler/icons-react";
import { numericFormatter } from "react-number-format";

interface Detalles {
  id: number;
  id_requisicion: number;
  id_movimiento: number;
  id_inventario: number;
  cantidad: number;
  precio_unitario: number;
  precio_total: number;
  comentarios: string;
  created_at: Date;
  estatus: number;
  inventario: Inventario | null;
}

interface Inventario {
  id: number;
  nombre: string;
  clave: string;
  cantidad: number;
  maximos: number;
  minimos: number;
  id_unidad_medida: number;
  id_categoria: number;
  id_ubicacion: number;
  id_tipo_producto: number;
  unidad_medida: UnidadMedida | null;
  categoria: Categoria | null;
  ubicacion: Ubicacion | null;
  tipo_producto: TipoProducto | null;
}

interface UnidadMedida {
  id: number;
  nombre: string;
}

interface Categoria {
  id: number;
  nombre: string;
}

interface Empresa {
  id: number;
  clave: string;
  razon_social: string;
  nombre: string;
  logo_empresa: string;
}

interface Ubicacion {
  id: number;
  nombre: string;
  id_almacen: number;
  almacen: Almacen | null;
}

interface Almacen {
  id: number;
  nombre: string;
}

interface TipoProducto {
  id: number;
  nombre: string;
}

interface CotizacionDetalle {
  id_inventario: number;
  nombre: string;
  clave: string;
  cantidad: number;
  precio_unitario: number;
  total: number;
  disponibilidad: number;
}

interface CotizacionProveedor {
  id: number;
  razon_social: string;
  seleccionado: number;
  subtotal: string;
  total: string;
  detalles: CotizacionDetalle[];
}

interface Cotizacion {
  id: number;
  estatus: number;
  observaciones: string | null;
  proveedores: CotizacionProveedor[];
}

interface ProveedorProducto {
  id_inventario: number;
  equipo?: string | null;
  nombre: string;
  clave: string | null;
  cantidad: number | string;
  precio_unitario: number | string;
  total: number | string;
  disponibilidad: number;
  tiene_oc: boolean;
}

interface ProveedoresSeleccionados {
  id: number;
  razon_social: string;
  nombre_comercial: string;
  contacto: string;
  correo: string;
  telefono: string;
  subtotal: number | string;
  total: number | string;
  productos: ProveedorProducto[];
}

interface Requisicion {
  id: number;
  folio: string;
  id_creador: number;
  id_usuario_solicitante: number;
  id_solicitud_computo?: number | null;
  nombre_creador: string;
  nombre_usuario: string;
  nombre_empresa: string;
  logo_empresa: string;
  ordenes_compra?: OrdenCompra[];
  cotizacion?: Cotizacion | null;
  proveedores_seleccionados?: ProveedoresSeleccionados[] | null;
  computo: string;
  computo_tipo: string;
  estatus_requisicion: number;
  id_empresa: number;
  id_proyecto: number;
  nombre_proyecto: string;
  extras: string;
  imagen_referencia: string;
  created_at: Date;
  empresa: Empresa;
  detalles: Detalles[];
  info_computo?: InfoComputo | null;
}

interface OrdenCompraDetalle {
  id: number;
  id_orden: number;
  id_inventario: number;
  cantidad: number;
  precio: number;
  precio_total: number;
  estatus?: number;
}

interface OrdenCompra {
  id: number;
  id_proveedor?: number | null;
  numero: string;
  estatus_id: number;
  estatus: string;
  detalles_orden_compra?: OrdenCompraDetalle[];
}

interface NivelJefeInmediato {
  id_usuario: number;
  jefe_inmediato: number;
  nivel: string;
  autorizo: boolean;
}

interface Proyecto {
  id: number;
  clave: number;
  nombre: string;
  descripcion: string;
  estatus: number;
  responsable: number;
  orden: number;
  vigente: number;
  participativo: number;
  dashboard: number;
  indirectos_campo: number;
  indirectos_oficina: number;
  financiamiento: number;
  utilidad: number;
  cargo_adicional_a: number;
  cargo_adicional_b: number;
  dias: number;
  id_bitacora: number;
}

interface Empresa {
  id: number;
  clave: string;
  razon_social: string;
  nombre: string;
  rfc: string;
  direccion: string;
  contacto: string;
  correo: string;
  telefono: string;
  logo: string;
  id_usuario: number;
  estatus: number;
  created_at: Date;
  updated_at: Date;
}

interface InfoComputo {
  tipo: string;
  notas: string;
  justificacion: string;
  notas_dsdt: string;
  items: InfoComputoItems[]
}


interface InfoComputoItems {
  id_equipo_adicional: number;
  tipo: string;
  cantidad: string;
  descripcion: string;
  programas: string;
  otro_programas: string;
  comprar: boolean;
  nombre: string;
  estatus: number;
  estatus_txt: string;
  comentario: string;
  color: string;
  categoria: string;
  asignado: string;
}

interface DetalleRequisicionProps {
  verRequisicion?: Requisicion | null;
  procesandoCotizacion?: boolean;
  enviarAutorizar: (datos: any) => Promise<void>;
  usuarioArjion?: string | null;
  procesoAutorizacion: (datos: any) => Promise<void>;
  idUsuario: number;
  accionRequisicion: string;
  handleAccionRequisicion: (
    event: React.MouseEvent<HTMLElement>,
    nuevaAccionRequisicion: string
  ) => void;
  jefeInmediato: NivelJefeInmediato[];
  nombreCompletoAutorizando?: string;
  setAccionRequisicion: React.Dispatch<React.SetStateAction<string>>;
  setVerCotizacion: React.Dispatch<React.SetStateAction<any>>;
  handleisAlertOpenCotizacion: () => void;
  procesandoProcesoAutorizacion?: boolean;
  surtirDisponible: (datos: any) => Promise<void>;
  procesandoSurtir?: boolean;
  handleisAlertCrearInventarioOpen: () => void;
  setIdDetalleRequisicion: React.Dispatch<React.SetStateAction<number>>;
  cancelarRequisicion: (datos: any) => Promise<void>;
  handleEditarRequisicion: (requisicion: any) => void;
  isModalImagenOpen: boolean;
  handleOpenModalImagen: () => void;
  handleCloseModalImagen: () => void;
  urlVerImagenReferencia?: string;
  marcarProductoAtendido: (datos: any) => Promise<void>;
  proyectos: Proyecto[];
  empresas: Empresa[];
  cambiarProyectoRequisicion: (datos: any) => Promise<void>;
  cambiarEmpresaRequisicion: (datos: any) => Promise<void>;

}

const filtrarProyectos = createFilterOptions<Proyecto>({
  stringify: (p) => `${p.nombre ?? ""} ${p.descripcion ?? ""}`,
  ignoreAccents: true,
  ignoreCase: true,
});

const filtrarEmpresas = createFilterOptions<Empresa>({
  stringify: (p) => `${p.nombre ?? ""} ${p.razon_social ?? ""}`,
  ignoreAccents: true,
  ignoreCase: true,
});

const CLAVES_SIN_ALERTA_INVENTARIO = ["PN-C-NI", "PN-A-NI"];

type ColorChip = "info" | "warning" | "primary" | "default" | "error" | "success";

const ESTADOS_ORDEN: Record<number, { texto: string; color: ColorChip }> = {
  1: { texto: "Generada", color: "info" },
  2: { texto: "Enviada", color: "warning" },
  4: { texto: "Aceptada", color: "success" },
  5: { texto: "Surtida", color: "success" },
  6: { texto: "Rechazada", color: "error" },
  7: { texto: "XML Validado", color: "warning" },
};

const traducirEstadoOrden = (estado?: number | null) =>
  ESTADOS_ORDEN[Number(estado)]?.texto ?? "SIN ESTADO";

const getEstadoOrdenColor = (estado?: number | null): ColorChip =>
  ESTADOS_ORDEN[Number(estado)]?.color ?? "default";

const formatoMoneda = (valor: number | string) =>
  numericFormatter(valor + "", {
    thousandSeparator: ",",
    decimalScale: 2,
    fixedDecimalScale: true,
    prefix: "$",
  });

interface TarjetaProveedorCotizadoProps {
  proveedor: ProveedoresSeleccionados;
  ordenes: OrdenCompra[];
}

const TarjetaProveedorCotizado = ({ proveedor, ordenes }: TarjetaProveedorCotizadoProps) => {
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState(3);

  const productos = useMemo(
    () => (proveedor.productos ?? []).filter((p) => p.tiene_oc),
    [proveedor.productos]
  );

  const totalConOC = useMemo(
    () => productos.reduce((sum, p) => sum + Number(p.total || 0), 0),
    [productos]
  );

  const productosPaginados = useMemo(
    () => productos.slice(page * rows, page * rows + rows),
    [productos, page, rows]
  );

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        border: "1px solid #e0e0e0",
        borderRadius: 2,
        //overflow: "hidden",
      }}
    >
      {/* Encabezado: datos del proveedor */}
      <Box
        sx={{
          position: "relative",
          p: 2,
          //pt: ordenes.length > 0 ? 5 : 2,
          backgroundColor: "#f5f9fc",
          borderBottom: "1px solid #e0e0e0",
          textAlign: "left",
        }}
      >
        {ordenes.length > 0 && (
          <Box
            sx={{
              position: "absolute",
              top: -10,
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              gap: 0.5,
              flexWrap: "nowrap",
              zIndex: 1,
            }}
          >
            {ordenes.map((oc) => (
              <Chip
                key={oc.id}
                size="small"
                icon={<IconFileInvoice size={16} stroke={2} />}
                label={`${oc.numero ?? `OC #${oc.id}`} · ${traducirEstadoOrden(oc.estatus_id).toUpperCase()}`}
                color={getEstadoOrdenColor(oc.estatus_id)}
                sx={{
                  fontWeight: "bold",
                  borderRadius: 2
                }}
              />
            ))}
          </Box>
        )}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 1 }}>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ color: "#084d6e" }} noWrap>
              {proveedor.nombre_comercial?.trim() || proveedor.razon_social}
            </Typography>
            <Typography variant="caption" color="text.secondary" display="block" noWrap>
              {proveedor.razon_social}
            </Typography>
          </Box>
          <Box sx={{ textAlign: "right", flexShrink: 0 }}>
            <Typography variant="caption" color="text.secondary" display="block">
              Total en OC
            </Typography>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ color: "#07177d" }}>
              {formatoMoneda(totalConOC)}
            </Typography>
          </Box>
        </Box>

        <Grid container spacing={1} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={4}>
            <Typography variant="caption" color="text.secondary" display="block">Contacto</Typography>
            <Typography variant="body2" fontWeight="medium" noWrap>
              {proveedor.contacto || "—"}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={5}>
            <Typography variant="caption" color="text.secondary" display="block">Correo</Typography>
            <Typography variant="body2" fontWeight="medium" sx={{ wordBreak: "break-all" }}>
              {proveedor.correo || "—"}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography variant="caption" color="text.secondary" display="block">Teléfono</Typography>
            <Typography variant="body2" fontWeight="medium">
              {proveedor.telefono || "—"}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* Productos de la OC */}
      <Box sx={{ p: 2, flexGrow: 1, display: "flex", flexDirection: "column" }}>
        <Typography variant="body2" fontWeight="bold" sx={{ mb: 1, textAlign: "left", color: "#004c93" }}>
          Productos ({productos.length})
        </Typography>

        <Box sx={{ flexGrow: 1 }}>
          {productosPaginados.map((producto, index) => (
            <Box
              key={`${producto.id_inventario}-${index}`}
              sx={{
                mb: 1,
                p: 1,
                border: "1px solid #eee",
                borderRadius: 1,
                backgroundColor: "#f1f8e9",
              }}
            >
              <Grid container spacing={1} alignItems="center">
                <Grid item xs={12} sm={5} sx={{ textAlign: "left" }}>
                  <Typography variant="body2" fontWeight="medium">
                    {producto.nombre}
                  </Typography>
                  {producto.clave && (
                    <Typography variant="caption" color="text.secondary">
                      {producto.clave}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={3} sm={2}>
                  <Typography variant="caption" color="text.secondary" display="block">
                    Cant.
                  </Typography>
                  <Typography variant="body2">{Number(producto.cantidad)}</Typography>
                </Grid>
                <Grid item xs={4} sm={2}>
                  <Typography variant="caption" color="text.secondary" display="block">
                    P. Unit.
                  </Typography>
                  <Typography variant="body2">{formatoMoneda(producto.precio_unitario)}</Typography>
                </Grid>
                <Grid item xs={5} sm={3}>
                  <Typography variant="caption" color="text.secondary" display="block">
                    Total
                  </Typography>
                  <Typography variant="body2" fontWeight="medium" sx={{ color: "#07177d" }}>
                    {formatoMoneda(producto.total)}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          ))}
        </Box>

        {productos.length > rows && (
          <TablePagination
            component="div"
            count={productos.length}
            page={page}
            onPageChange={(_, nuevaPagina) => setPage(nuevaPagina)}
            rowsPerPage={rows}
            onRowsPerPageChange={(e) => {
              setRows(parseInt(e.target.value, 10));
              setPage(0);
            }}
            rowsPerPageOptions={[3, 5, 10]}
            labelRowsPerPage="Por página:"
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
            sx={{
              ".MuiTablePagination-toolbar": { justifyContent: "space-between", padding: "0 8px" },
              ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": { margin: 0 },
              ".MuiTablePagination-actions svg": { transform: "scaleX(-1)" },
            }}
          />
        )}
      </Box>
    </Box>
  );
};

const DetallesRequisicion = ({
  verRequisicion,
  procesandoCotizacion,
  enviarAutorizar,
  usuarioArjion,
  procesoAutorizacion,
  idUsuario,
  accionRequisicion,
  handleAccionRequisicion,
  jefeInmediato,
  nombreCompletoAutorizando,
  setAccionRequisicion,
  handleisAlertOpenCotizacion,
  setVerCotizacion,
  procesandoProcesoAutorizacion,
  surtirDisponible,
  procesandoSurtir,
  handleisAlertCrearInventarioOpen,
  setIdDetalleRequisicion,
  cancelarRequisicion,
  handleEditarRequisicion,
  isModalImagenOpen,
  handleOpenModalImagen,
  handleCloseModalImagen,
  urlVerImagenReferencia,
  marcarProductoAtendido,
  proyectos,
  empresas,
  cambiarProyectoRequisicion,
  cambiarEmpresaRequisicion,
}: DetalleRequisicionProps) => {
  const intl = useIntl();

  const esRequisicionComputo = !!verRequisicion?.id_solicitud_computo;
  const infoComputo = verRequisicion?.info_computo;


  const [pageProduct, setPageProduct] = useState(0);
  const [nombreProducto, setNombreProducto] = useState<string | undefined>("");
  const [idProductoDetalle, setIdProductoDetalle] = useState<number>();
  const [rowsProductsPerPage, setRowsProductsPerPage] = useState(10);

  const [openConfirmEnviarDG, setOpenConfirmEnviarDG] = useState(false);

  //cambiar proyecto y empresa
  const [idProyecto, setIdProyecto] = useState<number>();
  const [nombreProyecto, setNombreProyecto] = useState<string>("");
  const [idEmpresa, setIdEmpresa] = useState<number>();
  const [nombreEmpresa, setNombreEmpresa] = useState<string>("");
  const [editarProyecto, setEditarProyecto] = useState(false);
  const [editarEmpresa, setEditarEmpresa] = useState(false);

  const [pageProveedores, setPageProveedores] = useState(0);
  const [rowsProveedores, setRowsProveedores] = useState(2);

  const handleConfirmar = (comentarios?: string) => {
    const datos = {
      id_requisicion: verRequisicion?.id,
      id_usuario_autorizando: idUsuario,
      total_requisicion: totalPedido,
      tipo_accion: accionRequisicion,
      que_es: tipoUsuarioArjion,
      ...verRequisicion,
    };
    const datosProductoDetalle = {
      id_requisicion: verRequisicion?.id,
      id_usuario: idUsuario,
      id_producto_detalle: idProductoDetalle,
      ...verRequisicion,
    };
    accionRequisicion === "cancelar"
      ? cancelarRequisicion(datos)
      : accionRequisicion === "marcar entregado"
        ? marcarProductoAtendido(datosProductoDetalle)
        : procesoAutorizacion(datos);
    setOpenConfirmEnviarDG(false);
  };

  const privilegiosToRol: Record<string, string> = {
    "froebel.ivan": "admin",
    "torres.tannya": "daf",
    "salazar.mario": "dg",
    "hernandez.lucero": "compras",
    "delarosa.brenda": "compras",
  };

  const tipoUsuarioArjion = privilegiosToRol[usuarioArjion as string] ?? "";

  const getEstadoColor = (
    estatus_requisicion: number
  ): "info" | "warning" | "primary" | "default" | "error" | "success" => {
    switch (estatus_requisicion) {
      case 1:
        return "info"; // Creada
      case 2:
        return "warning"; // Autorizada Jefe Inmediato
      case 3:
        return "primary"; // Autorizada Director
      case 4:
        return "primary"; // Autorizada DAF
      case 5:
        return "primary"; // Autorizada DG
      case 6:
        return "success"; // Atendida
      case 7:
        return "error"; // Rechazada
      case 8:
        return "warning"; // Pendiente DAF
      case 9:
        return "error"; // Cancelada
      case 10:
        return "warning"; // Pendiente DG
      case 11:
        return "warning"; // Cancelada
      case 12:
        return "info"; // Enviado a autorizar
      default:
        return "default";
    }
  };
  const getEstadoOrdenColor = (
    estatus_requisicion: number
  ): "info" | "warning" | "primary" | "default" | "error" | "success" => {
    switch (estatus_requisicion) {
      case 1:
        return "info"; // Generada
      case 2:
        return "warning"; // Enviada
      case 4:
        return "success"; // Aceptada
      case 5:
        return "success"; // Surtida
      case 6:
        return "error"; // Rechazada
      case 7:
        return "warning"; // XML Validado
      default:
        return "default";
    }
  };

  const colorChipComputo = (color?: string): "error" | "success" | "warning" | "default" => {
    switch (color) {
      case "danger":
        return "error";
      case "success":
        return "success";
      case "warning":
        return "warning";
      default:
        return "default";
    }
  };

  const estadosMap: { [key: number]: string } = {
    1: "Creada",
    2: "Autorizada Jefe Inmediato",
    3: "Autorizada Director de Area",
    4: "Autorizada DAF",
    5: "Autorizada DG",
    6: "Atendida",
    7: "Rechazada",
    8: "Pendiente DAF",
    9: "Cancelada",
    10: "Pendiente DG",
    11: "Cancelada",
    12: "Enviado a autorizar",
  };

  const estadosOrdenMap: { [key: number]: string } = {
    1: "Generada",
    2: "Enviada",
    4: "Aceptada",
    5: "Surtida",
    6: "Rechazada",
    7: "XML Validado",
  };

  // Función helper para traducir estados
  const traducirEstado = (estado: number | null): string => {
    if (estado === null || estado === undefined) return "SIN ESTADO";
    return estadosMap[estado] ?? "SIN ESTADO";
  };
  const traducirEstadoOrden = (estado: number | null): string => {
    if (estado === null || estado === undefined) return "SIN ESTADO";
    return estadosOrdenMap[estado] ?? "SIN ESTADO";
  };

  // Handlers para la paginación
  const handleChangePageProduct = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPageProduct(newPage);
  };

  const handleChangeRowsProductPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsProductsPerPage(parseInt(event.target.value, 10));
    setPageProduct(0);
  };

  const ordenesCompra = verRequisicion?.ordenes_compra ?? [];
  const tieneOrdenesCompra = ordenesCompra.length > 0;
  const proveedoresCotizados = useMemo(
    () =>
      (verRequisicion?.proveedores_seleccionados ?? []).filter((p) =>
        (p.productos ?? []).some((prod) => prod.tiene_oc)
      ),
    [verRequisicion?.proveedores_seleccionados]
  );
  const ordenesPorProveedor = useMemo(() => {
    const map = new Map<number, OrdenCompra[]>();
    (verRequisicion?.ordenes_compra ?? []).forEach((oc) => {
      if (oc.id_proveedor == null) return;
      const lista = map.get(Number(oc.id_proveedor)) ?? [];
      lista.push(oc);
      map.set(Number(oc.id_proveedor), lista);
    });
    return map;
  }, [verRequisicion?.ordenes_compra]);

  const detallesOrdenCompraMap = useMemo(() => {
    const map = new Map<number, OrdenCompraDetalle>();
    (verRequisicion?.ordenes_compra ?? []).forEach((oc) =>
      (oc.detalles_orden_compra ?? []).forEach((d) => map.set(d.id_inventario, d))
    );
    return map;
  }, [verRequisicion?.ordenes_compra]);

  const tieneOrdenCompraConDetalles = detallesOrdenCompraMap.size > 0;

  const proveedoresPaginados = useMemo(
    () =>
      proveedoresCotizados.slice(
        pageProveedores * rowsProveedores,
        pageProveedores * rowsProveedores + rowsProveedores
      ),
    [proveedoresCotizados, pageProveedores, rowsProveedores]
  );

  const totalPedido = useMemo(() => {
    const detalles = verRequisicion?.detalles ?? [];
    return detalles.reduce((sum, d) => {
      const detalleOC = tieneOrdenCompraConDetalles
        ? detallesOrdenCompraMap.get(d.id_inventario)
        : undefined;
      const total = detalleOC ? detalleOC.precio_total : d.precio_total;
      return sum + Number(total);
    }, 0);
  }, [verRequisicion?.detalles, tieneOrdenCompraConDetalles, detallesOrdenCompraMap]);

  const colorMap: Record<string, { background: string; color: string }> = {
    autorizar: { background: "#4caf50", color: "#fff" },
    rechazar: { background: "#f44336", color: "#fff" },
    "enviar a dg": { background: "#ff9800", color: "#fff" },
  };

  const defaultStyle = { background: "#31a3dc", color: "#fff" };

  const actionStyle = accionRequisicion
    ? colorMap[accionRequisicion] ?? defaultStyle
    : defaultStyle;

  const todosSurtidosCompletamente = useMemo(() => {
    const detalles = verRequisicion?.detalles ?? [];
    return detalles.length > 0 && detalles.every((d) => d.cantidad === 0);
  }, [verRequisicion?.detalles]);

  const productosConAlerta = useMemo(() => {
    const detalles = verRequisicion?.detalles ?? [];
    return detalles.map((producto) => {
      const esSinAlerta = CLAVES_SIN_ALERTA_INVENTARIO.includes(producto.inventario?.clave ?? "");

      const cantidadDisponible = producto.inventario?.cantidad ?? 0;
      const cantidadPedida = producto.cantidad ?? 0;
      const minimos = producto.inventario?.minimos ?? 0;

      const cantidadRestante = Math.max(0, cantidadDisponible - cantidadPedida);
      const cantidadFaltante = Math.max(0, cantidadPedida - cantidadDisponible);
      const quedaBajoMinimo = !esSinAlerta && cantidadDisponible > 0 && cantidadRestante <= minimos;
      const yaEnMinimos = !esSinAlerta && cantidadDisponible <= minimos;

      return {
        ...producto,
        cantidadRestante,
        quedaBajoMinimo,
        yaEnMinimos,
        cantidadFaltante,
        esSinAlerta,
      };
    });
  }, [verRequisicion?.detalles]);

  const hayProductosYaEnMinimos = productosConAlerta.some((d) => d.yaEnMinimos);
  const hayProductosBajoMinimo = productosConAlerta.some((d) => d.quedaBajoMinimo);

  const productosSinInventario = useMemo(() => {
    return productosConAlerta.filter(
      (p) => !p.esSinAlerta && p.inventario?.cantidad === 0 && p?.cantidad !== 0
    );
  }, [productosConAlerta]);

  const productosSurtidosCompletamente = useMemo(() => {
    return productosConAlerta.filter((p) => !p.esSinAlerta && p?.cantidad === 0);
  }, [productosConAlerta]);

  const hayProductosSinInventario = productosSinInventario.length > 0;
  const hayProductosSurtidosCompletamente = productosSurtidosCompletamente.length > 0;

  const productosParaSurtir = useMemo(() => {
    return productosConAlerta.filter((p) => (p.inventario?.cantidad ?? 0) > 0 && p?.cantidad !== 0);
  }, [productosConAlerta]);

  const alertCenteredSx = {
    m: 2,
    justifyContent: "center",
    textAlign: "center",
  };
  const alertLeftSx = { mb: 2, textAlign: "left !important" };

  const productosConAlertaPaginados = useMemo(() => {
    const startIndex = pageProduct * rowsProductsPerPage;
    const endIndex = startIndex + rowsProductsPerPage;
    return productosConAlerta.slice(startIndex, endIndex);
  }, [productosConAlerta, pageProduct, rowsProductsPerPage]);

  const urlLogoEmpresa = verRequisicion?.empresa.logo_empresa
    ? `${env.API_URL_ASSETS}logo_empresas/${verRequisicion?.empresa.logo_empresa}`
    : null;

  //obtenemos los jefes inmediatos sin importar el nivel pero que ya hayan autorizado
  const esJefeInmediatoDeAlgunNivel = useMemo(() => {
    return jefeInmediato?.some((nivel) => (nivel.id_usuario === idUsuario) == nivel.autorizo === false) ?? false;
  }, [jefeInmediato, idUsuario]);

  const esJefeInmediatoNivelA = useMemo(() => {
    return (
      jefeInmediato?.some((nivel) => nivel.id_usuario === idUsuario && nivel.nivel === "A") ?? false
    );
  }, [jefeInmediato, idUsuario]);

  const puedeRechazar =
    (esJefeInmediatoNivelA && verRequisicion?.estatus_requisicion === 1) ||
    (esJefeInmediatoDeAlgunNivel && verRequisicion?.estatus_requisicion === 1) ||
    (esJefeInmediatoDeAlgunNivel && verRequisicion?.estatus_requisicion === 2) ||
    (tipoUsuarioArjion === "dg" && verRequisicion?.estatus_requisicion === 10) ||
    (tipoUsuarioArjion === "daf" && verRequisicion?.estatus_requisicion === 8);
  const puedeCancelar =
    idUsuario === verRequisicion?.id_creador && verRequisicion.estatus_requisicion === 1;
  const puedeEditar =
    idUsuario === verRequisicion?.id_creador &&
    (verRequisicion.estatus_requisicion === 7 || verRequisicion.estatus_requisicion === 9);
  const puedeAutorizar =
    (esJefeInmediatoDeAlgunNivel && verRequisicion?.estatus_requisicion === 1) ||
    (esJefeInmediatoDeAlgunNivel && verRequisicion?.estatus_requisicion === 2) ||
    (tipoUsuarioArjion === "daf" && verRequisicion?.estatus_requisicion === 8) ||
    (tipoUsuarioArjion === "dg" && verRequisicion?.estatus_requisicion === 10);
  const puedeCotizarMandarDAF = !esRequisicionComputo && todosSurtidosCompletamente;
  const puedeSurtirDisponible = productosParaSurtir.length === 0;
  const puedeEnviarAutorizarPrimeraVez =
    idUsuario === verRequisicion?.id_creador && verRequisicion.estatus_requisicion === 1;
  const puedeGestionarCompras =
    tipoUsuarioArjion === "compras" && verRequisicion?.estatus_requisicion === 3;

  const itemsComputoPaginados = useMemo(() => {
    const items = infoComputo?.items ?? [];
    const start = pageProduct * rowsProductsPerPage;
    return items.slice(start, start + rowsProductsPerPage);
  }, [infoComputo?.items, pageProduct, rowsProductsPerPage]);

  useEffect(() => {
    setPageProveedores(0);
  }, [verRequisicion?.id]);

  if (!verRequisicion) return null;

  return (
    <Box sx={{ px: 0, pb: 0, mt: 0, position: "relative", textAlign: "center" }}>
      <Grid container spacing={2} sx={{ p: 0 }}>
        {!tieneOrdenesCompra &&
          tipoUsuarioArjion === "compras" &&
          verRequisicion.estatus_requisicion === 3 && (
            <Grid item xs={12}>
              {!todosSurtidosCompletamente ? (
                <Alert severity="info" sx={alertCenteredSx}>
                  Al surtir los productos disponibles, se restará lo solicitado de la cantidad
                  disponible en inventario y el resto se deberá cotizar
                </Alert>
              ) : (
                <Alert severity="success" sx={alertCenteredSx}>
                  Todos los productos han sido surtidos completamente
                </Alert>
              )}
            </Grid>
          )}

        <Grid item xs={12} md={2}>
          <Typography variant="body2" color="text.secondary">
            Logo de la empresa
          </Typography>
          {urlLogoEmpresa ? (
            <Box
              component="img"
              src={urlLogoEmpresa}
              alt="Imagen de referencia"
              sx={{
                mt: 0.5,
                width: "auto",
                height: 40,
              }}
            />
          ) : (
            <Typography variant="body2" fontWeight="medium">
              Sin imagen de referencia
            </Typography>
          )}
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Estatus de la requisición
          </Typography>
          <Chip
            label={traducirEstado(verRequisicion.estatus_requisicion).toUpperCase()}
            color={getEstadoColor(verRequisicion.estatus_requisicion)}
            sx={{ fontWeight: "bold" }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={7}
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: { xs: "center", sm: "end" },
          }}
          gap={1}
        >
          {!tieneOrdenesCompra && (
            <>
              {tipoUsuarioArjion == "compras" && (
                <>
                  <Button
                    sx={{
                      color: "#fff",
                      background: "#247839",
                      fontSize: "0.75rem",
                      padding: "6px 8px",
                      "&:hover": {
                        background: "#134a21",
                      },
                      "&:focus": {
                        background: "#134a21 !important",
                      },
                    }}
                    variant="contained"
                    disabled={
                      puedeSurtirDisponible || [1, 2].includes(verRequisicion.estatus_requisicion)
                    }
                    startIcon={<IconShoppingCartCopy stroke={2} />}
                    onClick={(e: any) => {
                      const datos = {
                        id_requisicion: verRequisicion?.id,
                        id_usuario_surtiendo: idUsuario,
                        id_creador: verRequisicion?.id_creador,
                        id_usuario_solicitante: verRequisicion?.id_usuario_solicitante,
                        total_requisicion: totalPedido,
                        detalles: productosParaSurtir,
                        ids_inventario: verRequisicion.detalles.map((d) => d.id_inventario),
                      };
                      surtirDisponible(datos);
                    }}
                  >
                    {procesandoSurtir ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                        Surtiendo...{" "}
                      </>
                    ) : (
                      intl.formatMessage({ id: "general_surtir_disponible" })
                    )}
                  </Button>
                  {/* CAPACIDAD DE COTIZAR O MANDAR A DAF*/}
                  <Button
                    sx={{
                      color: "#000",
                      background: "#dec162",
                      fontSize: "0.75rem",
                      padding: "6px 8px",
                      "&:hover": {
                        background: "#826f30",
                      },
                      "&:focus": {
                        background: "#826f30 !important",
                      },
                    }}
                    variant="contained"
                    disabled={
                      puedeCotizarMandarDAF ||
                      [1, 2, 4, 6, 7, 8, 9].includes(verRequisicion.estatus_requisicion)
                    }
                    startIcon={<IconReportSearch stroke={2} />}
                    onClick={(e: any) => {
                      const nuevaAccion =
                        totalPedido >= 50000 && verRequisicion.estatus_requisicion === 3
                          ? "mandar a daf"
                          : "cotizar";
                      setAccionRequisicion(nuevaAccion);

                      const idsInventario = esRequisicionComputo
                        ? verRequisicion?.info_computo?.tipo : verRequisicion.detalles
                          .filter((p) => p.cantidad !== 0)
                          .map((d) => d.id_inventario);

                      const datos = {
                        id_requisicion: verRequisicion?.id,
                        id_usuario_autorizando: idUsuario,
                        total_requisicion: totalPedido,
                        tipo_accion: nuevaAccion,
                        ...verRequisicion,
                        ids_inventario: idsInventario,
                      };
                      if (totalPedido >= 50000 && verRequisicion.estatus_requisicion === 3) {
                        setAccionRequisicion("mandar a daf");
                        setOpenConfirmEnviarDG(true);
                      } else {
                        setVerCotizacion(datos);
                        handleisAlertOpenCotizacion();
                      }
                    }}
                  >
                    {totalPedido >= 50000 && verRequisicion.estatus_requisicion === 3 ? (
                      intl.formatMessage({ id: "general_mandar_daf" })
                    ) : (
                      intl.formatMessage({ id: "general_cotizar" })
                    )}
                  </Button>
                </>
              )}

              {/* BOTONES DE ACCIONES POR SEPARADO */}
              {/* ENVIAR A DG POR DAF SI TIENE ESTATUS PENDIENTE DAF */}
              {tipoUsuarioArjion === "daf" && verRequisicion.estatus_requisicion === 8 && (
                <Button
                  sx={{
                    background: "#ff9800",
                    color: "#fff",
                    fontSize: "0.75rem",
                    padding: "6px 8px",
                    "&:hover": {
                      background: "#a66302",
                    },
                    "&:focus": {
                      background: "#a66302 !important",
                    },
                  }}
                  variant="contained"
                  startIcon={<IconCoffee stroke={2} />}
                  disabled={verRequisicion.estatus_requisicion !== 8}
                  onClick={(e: any) => {
                    setAccionRequisicion("enviar a dg");
                    setOpenConfirmEnviarDG(true);
                  }}
                >
                  {
                    intl.formatMessage({ id: "enviar_a_dg" })
                  }
                </Button>
              )}
              {/* MANDAR A AUTORIZAR POR PRIMERA VEZ SOLO POR EL CREADOR */}
              <Button
                sx={{
                  ...actionStyle,
                  fontSize: "0.75rem",
                  padding: "6px 8px",
                }}
                variant="contained"
                startIcon={<IconBrandAuth0 stroke={2} />}
                disabled={!puedeEnviarAutorizarPrimeraVez}
                onClick={(e: any) => {
                  const datos = {
                    id_requisicion: verRequisicion?.id,
                    id_usuario: idUsuario,
                    ...verRequisicion,
                  };
                  enviarAutorizar(datos);
                }}
              >
                {
                  intl.formatMessage({ id: "general_enviar_autorizar" })
                }
              </Button>
              {/* CAPACIDAD DE AUTORIZAR*/}
              <Button
                sx={{
                  color: "#fff",
                  background: "#3ec972",
                  fontSize: "0.75rem",
                  padding: "6px 8px",
                  "&:hover": {
                    background: "#269951",
                  },
                  "&:focus": {
                    background: "#269951 !important",
                  },
                }}
                variant="contained"
                startIcon={<IconCheckupList stroke={2} />}
                disabled={
                  !puedeAutorizar || [5, 6, 7, 9].includes(verRequisicion.estatus_requisicion)
                }
                onClick={(e: any) => {
                  setAccionRequisicion("autorizar");
                  setOpenConfirmEnviarDG(true);
                }}
              >
                {intl.formatMessage({ id: "general_autorizar" })}
              </Button>
              {/* CAPACIDAD DE RECHAZAR LA REQUISICIÓN POR EL JEFE INMEDIATO*/}
              {esJefeInmediatoDeAlgunNivel ||
                ![6, 7, 9].includes(verRequisicion.estatus_requisicion) ? (
                <Button
                  sx={{
                    background: "#ab1829",
                    color: "#fff",
                    fontSize: "0.75rem",
                    padding: "6px 8px",
                    "&:hover": {
                      background: "#6b0d18",
                    },
                    "&:focus": {
                      background: "#6b0d18 !important",
                    },
                  }}
                  variant="contained"
                  startIcon={<IconThumbDown stroke={2} />}
                  disabled={!puedeRechazar}
                  onClick={(e: any) => {
                    setAccionRequisicion("rechazar");
                    setOpenConfirmEnviarDG(true);
                  }}
                >
                  {
                    intl.formatMessage({ id: "general_rechazar" })
                  }
                </Button>
              ) : null}
              {idUsuario === verRequisicion?.id_creador ? (
                <>
                  {puedeEditar && (
                    <Button
                      sx={{
                        background: "#6a4fb3",
                        color: "#fff",
                        fontSize: "0.75rem",
                        padding: "6px 8px",
                        "&:hover": { background: "#4b3585" },
                        "&:focus": { background: "#4b3585 !important" },
                      }}
                      variant="contained"
                      startIcon={<IconEdit stroke={2} />}
                      onClick={() => handleEditarRequisicion(verRequisicion)}
                    >
                      Editar requisición
                    </Button>
                  )}
                  <Button
                    sx={{
                      background: "#ab1829",
                      color: "#fff",
                      fontSize: "0.75rem",
                      padding: "6px 8px",
                      "&:hover": {
                        background: "#6b0d18",
                      },
                      "&:focus": {
                        background: "#6b0d18 !important",
                      },
                    }}
                    variant="contained"
                    startIcon={<IconCancel stroke={2} />}
                    disabled={!puedeCancelar}
                    onClick={(e: any) => {
                      setAccionRequisicion("cancelar");
                      setOpenConfirmEnviarDG(true);
                    }}
                  >
                    {
                      intl.formatMessage({ id: "general_cancelar" })
                    }
                  </Button>
                </>
              ) : null}
            </>
          )}
        </Grid>
        {/* Info general */}
        <Grid item xs={12}>
          <Paper elevation={2} sx={{ p: 2 }}>
            <Typography variant="h6" color="primary" gutterBottom sx={{ color: "#004c93" }}>
              Información general
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" color="text.secondary">
                  Creado por
                </Typography>
                <Typography variant="body2" fontWeight="medium">
                  {verRequisicion.nombre_creador}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" color="text.secondary">
                  Usuario solicitante
                </Typography>
                <Typography variant="body2" fontWeight="medium">
                  {verRequisicion.nombre_usuario}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="body2" color="text.secondary">
                  Proyecto
                </Typography>

                {editarProyecto ? (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.5 }}>
                    <Autocomplete
                      id="proyectos"
                      filterOptions={filtrarProyectos}
                      fullWidth
                      size="small"
                      options={proyectos}
                      disabled={proyectos.length === 0}
                      getOptionLabel={(option) => option.nombre ?? ""}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      value={proyectos.find((p) => p.id === idProyecto) ?? null}
                      onChange={(_, nuevo) => {
                        setIdProyecto(nuevo?.id);
                        setNombreProyecto(nuevo?.nombre ?? "");
                      }}
                      noOptionsText={intl.formatMessage({ id: "general_sin_registros" })}
                      renderOption={(props, option) => (
                        <li {...props} key={option.id}>
                          <Box sx={{ textAlign: "left" }}>
                            <Typography variant="body2">{option.nombre}</Typography>
                            {option.descripcion && (
                              <Typography variant="caption" color="text.secondary">
                                {option.descripcion}
                              </Typography>
                            )}
                          </Box>
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="Proyecto"
                          helperText={
                            proyectos.length === 0 ? "No hay proyectos registrados" : undefined
                          }
                        />
                      )}
                    />
                    <Tooltip title="Guardar">
                      <IconButton
                        size="small"
                        disabled={!idProyecto || idProyecto === verRequisicion.id_proyecto}
                        onClick={() => {
                          cambiarProyectoRequisicion({
                            id_requisicion: verRequisicion.id,
                            id_proyecto: idProyecto,
                            nombre_proyecto: nombreProyecto,
                            id_usuario: idUsuario,
                          });
                          setEditarProyecto(false);
                        }}
                      >
                        <IconCheck stroke={2} color="#6aa84f" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Cancelar">
                      <IconButton size="small" onClick={() => setEditarProyecto(false)}>
                        <IconX stroke={2} color="#ab1829" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 0.5,
                    }}
                  >
                    <Typography variant="body2" fontWeight="medium">
                      {verRequisicion.nombre_proyecto}
                    </Typography>
                    {(tipoUsuarioArjion === "compras" || tipoUsuarioArjion === "daf") && (
                      <Tooltip title="Cambiar proyecto">
                        <IconButton size="small" onClick={() => setEditarProyecto(true)}>
                          <IconPencil size={16} stroke={2} />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Box>
                )}
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="body2" color="text.secondary">
                  Empresa
                </Typography>

                {editarEmpresa ? (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.5 }}>
                    <Autocomplete
                      id="empresas"
                      filterOptions={filtrarEmpresas}
                      fullWidth
                      size="small"
                      options={empresas}
                      disabled={empresas.length === 0}
                      getOptionLabel={(option) => option.nombre ?? ""}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      value={empresas.find((p) => p.id === idEmpresa) ?? null}
                      onChange={(_, nuevo) => {
                        setIdEmpresa(nuevo?.id);
                        setNombreEmpresa(nuevo?.nombre ?? "");
                      }}
                      noOptionsText={intl.formatMessage({ id: "general_sin_registros" })}
                      renderOption={(props, option) => (
                        <li {...props} key={option.id}>
                          <Box sx={{ textAlign: "left" }}>
                            <Typography variant="body2">{option.nombre}</Typography>
                            {option.razon_social && (
                              <Typography variant="caption" color="text.secondary">
                                {option.razon_social}
                              </Typography>
                            )}
                          </Box>
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="Empresa"
                          helperText={
                            empresas.length === 0 ? "No hay empresas registradas" : undefined
                          }
                        />
                      )}
                    />
                    <Tooltip title="Guardar">
                      <IconButton
                        size="small"
                        disabled={!idEmpresa || idEmpresa === verRequisicion.id_empresa}
                        onClick={() => {
                          cambiarEmpresaRequisicion({
                            id_requisicion: verRequisicion.id,
                            id_empresa: idEmpresa,
                            nombre_empresa: nombreEmpresa,
                            id_usuario: idUsuario,
                          });
                          setEditarEmpresa(false);
                        }}
                      >
                        <IconCheck stroke={2} color="#6aa84f" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Cancelar">
                      <IconButton size="small" onClick={() => setEditarEmpresa(false)}>
                        <IconX stroke={2} color="#ab1829" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 0.5,
                    }}
                  >
                    <Typography variant="body2" fontWeight="medium">
                      {verRequisicion.nombre_empresa}
                    </Typography>
                    {(tipoUsuarioArjion === "compras" || tipoUsuarioArjion === "daf") && (
                      <Tooltip title="Cambiar empresa">
                        <IconButton
                          size="small"
                          onClick={() => {
                            setEditarEmpresa(true);
                          }}
                        >
                          <IconPencil size={16} stroke={2} />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Box>
                )}
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="body2" color="text.secondary">
                  Fecha
                </Typography>
                <Typography variant="body2" fontWeight="medium">
                  {new Date(verRequisicion.created_at).toLocaleDateString("es-MX")}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        {/* Info referencias */}
        <Grid item xs={12}>
          <Paper elevation={2} sx={{ p: 2 }}>
            <Typography variant="h6" color="primary" gutterBottom sx={{ color: "#004c93" }}>
              Referencias
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" color="text.secondary">
                  Link/comentarios
                </Typography>
                <Typography variant="body2" fontWeight="medium">
                  {verRequisicion.extras}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" color="text.secondary">
                  Imagen referencia
                </Typography>
                {urlVerImagenReferencia ? (
                  <Box
                    component="img"
                    src={urlVerImagenReferencia}
                    alt="Imagen de referencia"
                    onClick={handleOpenModalImagen}
                    sx={{
                      mt: 0.5,
                      width: 100,
                      height: 100,
                      objectFit: "cover",
                      borderRadius: 1,
                      border: "1px solid #e0e0e0",
                      cursor: "pointer",
                      "&:hover": { opacity: 0.85 },
                    }}
                  />
                ) : (
                  <Typography variant="body2" fontWeight="medium">
                    Sin imagen de referencia
                  </Typography>
                )}
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        {/* DETALLES DE LAS ORDENES DE COMPRA */}
        {proveedoresCotizados.length > 0 && (
          <Grid item xs={12}>
            <Paper elevation={2} sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom sx={{ color: "#004c93" }}>
                {proveedoresCotizados.length === 1
                  ? "Proveedor con orden de compra"
                  : `Proveedores con orden de compra (${proveedoresCotizados.length})`}
              </Typography>
              <Divider sx={{ mb: 2 }} />

              <Grid container spacing={2} alignItems="stretch">
                {proveedoresPaginados.map((proveedor) => (
                  <Grid item xs={12} md={6} key={proveedor.id}>
                    <TarjetaProveedorCotizado
                      proveedor={proveedor}
                      ordenes={ordenesPorProveedor.get(Number(proveedor.id)) ?? []}
                    />
                  </Grid>
                ))}
              </Grid>

              {proveedoresCotizados.length > rowsProveedores && (
                <TablePagination
                  component="div"
                  count={proveedoresCotizados.length}
                  page={pageProveedores}
                  onPageChange={(_, nuevaPagina) => setPageProveedores(nuevaPagina)}
                  rowsPerPage={rowsProveedores}
                  onRowsPerPageChange={(e) => {
                    setRowsProveedores(parseInt(e.target.value, 10));
                    setPageProveedores(0);
                  }}
                  rowsPerPageOptions={[2, 4, 6]}
                  labelRowsPerPage="Proveedores por página:"
                  labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                  sx={{
                    mt: 1,
                    ".MuiTablePagination-toolbar": { justifyContent: "space-between", padding: "8px 16px" },
                    ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": { margin: 0 },
                    ".MuiTablePagination-actions svg": { transform: "scaleX(-1)" },
                  }}
                />
              )}
            </Paper>
          </Grid>
        )}

        {/* INFORMACIÓN DE EQUIPO DE COMPUTO */}
        {(esRequisicionComputo && !proveedoresCotizados.length) && (
          <Grid item xs={12}>
            <Paper elevation={2} sx={{ p: 2 }}>
              <Typography
                variant="h6"
                gutterBottom
                sx={{ color: "#004c93", textAlign: "center" }}
              >
                Equipo de cómputo{" "}
                {verRequisicion.computo_tipo === "adicional" ? "(adicional)" : ""}
              </Typography>
              <Divider sx={{ mb: 2 }} />

              {!infoComputo ? (
                <Alert severity="warning" sx={alertCenteredSx}>
                  No se pudo obtener la información de la solicitud de cómputo
                </Alert>
              ) : (
                <>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} md={4}>
                      <Typography variant="body2" color="text.secondary">
                        Notas
                      </Typography>
                      <Typography variant="body2" fontWeight="medium">
                        {infoComputo.notas || "—"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Typography variant="body2" color="text.secondary">
                        Justificación
                      </Typography>
                      <Typography variant="body2" fontWeight="medium">
                        {infoComputo.justificacion || "—"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Typography variant="body2" color="text.secondary">
                        Notas DSDT
                      </Typography>
                      <Typography variant="body2" fontWeight="medium">
                        {infoComputo.notas_dsdt || "—"}
                      </Typography>
                    </Grid>
                  </Grid>

                  <Typography variant="body2" fontWeight="bold" sx={{ color: "#004c93", mb: 1 }}>
                    Artículos solicitados ({infoComputo.items?.length ?? 0})
                  </Typography>

                  {!infoComputo.items?.length ? (
                    <Alert severity="info" sx={alertCenteredSx}>
                      No hay artículos por comprar en esta solicitud
                    </Alert>
                  ) : (
                    itemsComputoPaginados.map((item, index) => (
                      <Box
                        key={`${item.tipo}-${item.nombre}-${index}`}
                        sx={{
                          mb: 1,
                          p: 1,
                          border: "1px solid #e0e0e0",
                          borderRadius: 1,
                        }}
                      >
                        <Grid container spacing={1} alignItems="center">
                          <Grid item xs={6} md={3}>
                            <Typography variant="body2" color="text.secondary">
                              Tipo
                            </Typography>
                            <Typography variant="body2" fontWeight="medium">
                              {item.tipo}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} md={3}>
                            <Typography variant="body2" color="text.secondary">
                              Artículo
                            </Typography>
                            <Typography variant="body2" fontWeight="medium">
                              {item.nombre || item.descripcion}
                            </Typography>
                            {item.categoria && (
                              <Typography variant="caption" color="text.secondary">
                                {item.categoria}
                              </Typography>
                            )}
                          </Grid>
                          <Grid item xs={6} md={2}>
                            <Typography variant="body2" color="text.secondary">
                              Cantidad
                            </Typography>
                            <Typography variant="body2" fontWeight="medium">
                              {item.cantidad || 1}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} md={2}>
                            <Typography variant="body2" color="text.secondary">
                              Estatus
                            </Typography>
                            <Chip
                              label={item.estatus_txt}
                              color={colorChipComputo(item.color)}
                              size="small"
                              sx={{ fontWeight: "bold" }}
                            />
                          </Grid>
                          <Grid item xs={12} md={2}>
                            <Typography variant="body2" color="text.secondary">
                              Comentario
                            </Typography>
                            <Typography variant="body2" fontWeight="medium">
                              {item.comentario || "—"}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    ))
                  )}
                </>
              )}
              {/* Paginación */}
              <TablePagination
                component="div"
                count={verRequisicion.info_computo?.items?.length ?? 0}
                page={pageProduct}
                onPageChange={handleChangePageProduct}
                rowsPerPage={rowsProductsPerPage}
                onRowsPerPageChange={handleChangeRowsProductPerPage}
                rowsPerPageOptions={[3, 5, 10]}
                labelRowsPerPage="Por página:"
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                sx={{
                  ".MuiTablePagination-toolbar": {
                    justifyContent: "space-between",
                    padding: "8px 16px",
                  },
                  ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
                    margin: 0,
                  },
                  ".MuiTablePagination-actions svg": { transform: "scaleX(-1)" },
                }}
              />
            </Paper>
          </Grid>
        )}

        {/* Detalles / productos */}
        {proveedoresCotizados.length > 0 || esRequisicionComputo ? null : (
          <Grid item xs={12}>
            <Paper elevation={2} sx={{ p: 2 }}>
              <Typography
                variant="h6"
                color="primary"
                gutterBottom
                sx={{ color: "#07177d", textAlign: "center" }}
              >
                Productos solicitados ({verRequisicion.detalles?.length ?? 0})
              </Typography>
              <Divider sx={{ mb: 2 }} />

              {(tipoUsuarioArjion === "compras" && hayProductosYaEnMinimos && !esRequisicionComputo) && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  Algunos productos ya se encuentran en su nivel mínimo (o por debajo) de inventario
                </Alert>
              )}
              {(tipoUsuarioArjion === "compras" && hayProductosSinInventario && !esRequisicionComputo) && (
                <Alert severity="error" sx={{ ...alertLeftSx }}>
                  {productosSinInventario.length === 1 ? (
                    `El producto "${productosSinInventario[0].inventario?.nombre}" no tiene inventario disponible y no se incluirá al surtir (será necesario cotizarlo)`
                  ) : (
                    <>
                      Los siguientes productos no tienen inventario disponible y no se incluirán al
                      surtir (será necesario cotizarlos):
                      <Box component="ul" sx={{ m: 0, pl: 3 }}>
                        {productosSinInventario.map((p) => (
                          <li key={p.id}>{p.inventario?.nombre}</li>
                        ))}
                      </Box>
                    </>
                  )}
                </Alert>
              )}
              {tipoUsuarioArjion === "compras" && hayProductosSurtidosCompletamente && (
                <Alert severity="success" sx={{ ...alertLeftSx }}>
                  {productosSurtidosCompletamente.length === 1 ? (
                    `El producto "${productosSurtidosCompletamente[0].inventario?.nombre}" se ha surtido completamente y no se incluirá al cotizar`
                  ) : (
                    <>
                      Los siguientes se surtieron completamente y no se incluirán al cotizar:
                      <Box component="ul" sx={{ m: 0, pl: 3 }}>
                        {productosSurtidosCompletamente.map((p) => (
                          <li key={p.id}>{p.inventario?.nombre}</li>
                        ))}
                      </Box>
                    </>
                  )}
                </Alert>
              )}
              {tipoUsuarioArjion === "compras" && hayProductosBajoMinimo && (
                <Alert severity="warning" sx={{ mb: 2 }}>
                  Algunos productos quedarían por debajo del minimo después de surtirlos
                </Alert>
              )}

              {productosConAlertaPaginados.map((detalle, index: number) => {
                const detalleOC = tieneOrdenCompraConDetalles
                  ? detallesOrdenCompraMap.get(detalle.id_inventario)
                  : undefined;

                const precioUnitarioMostrar = detalleOC
                  ? detalleOC.precio
                  : detalle.precio_unitario;
                const precioTotalMostrar = detalleOC
                  ? detalleOC.precio_total
                  : detalle.precio_total;

                return (
                  <Box
                    key={detalle.id}
                    sx={{
                      mb: 2,
                      p: 1,
                      pt: detalle?.estatus === 4 ? 3.5 : 1,
                      position: "relative",
                      border:
                        detalle?.estatus === 4
                          ? "1px solid #6aa84f"
                          : detalle.esSinAlerta && tipoUsuarioArjion === "compras"
                            ? "1px solid #e0e0e0"
                            : tipoUsuarioArjion === "compras" && detalle?.cantidad === 0
                              ? "1px solid #4caf50"
                              : tipoUsuarioArjion === "compras" &&
                                (detalle.inventario?.cantidad ?? 0) === 0
                                ? "1px solid #f44336"
                                : tipoUsuarioArjion === "compras" && detalle.yaEnMinimos
                                  ? "1px solid #d32f2f"
                                  : detalle.quedaBajoMinimo && tipoUsuarioArjion === "compras"
                                    ? "1px solid #ff9800"
                                    : "1px solid #e0e0e0",
                      borderRadius: 1,
                      backgroundColor:
                        detalle?.estatus === 4
                          ? "#deffd0"
                          : detalle.esSinAlerta && tipoUsuarioArjion === "compras"
                            ? "transparent"
                            : tipoUsuarioArjion === "compras" && detalle?.cantidad === 0
                              ? "#e8f5e9"
                              : tipoUsuarioArjion === "compras" &&
                                (detalle.inventario?.cantidad ?? 0) === 0
                                ? "#ffebee"
                                : tipoUsuarioArjion === "compras" && detalle.yaEnMinimos
                                  ? "#fdecea"
                                  : detalle.quedaBajoMinimo && tipoUsuarioArjion === "compras"
                                    ? "#fff3e0"
                                    : "transparent",
                    }}
                  >
                    {detalle.esSinAlerta && tipoUsuarioArjion === "compras" && (
                      <>
                        <Box
                          sx={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            display: "flex",
                            alignItems: "center",
                            color: "#31a3dc",
                            border: "1px solid #8da4f0",
                            p: 0.5,
                            "&:hover": {
                              background: "#31a3dc",
                              color: "#fff",
                              cursor: "pointer",
                            },
                          }}
                          onClick={(e: any) => {
                            setIdDetalleRequisicion(detalle.id);
                            handleisAlertCrearInventarioOpen();
                          }}
                        >
                          <IconCopyPlusFilled size={30} />
                        </Box>
                      </>
                    )}
                    {detalle?.estatus === 4 && (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          display: "flex",
                          alignItems: "center",
                          color: "#000",
                          border: "1px solid #6aa84f",
                          p: 0.5,
                          fontSize: 10,
                          fontWeight: 600,
                          background: "#FFFDD0",
                        }}
                      >
                        <IconPackageExport stroke={2} size={14} style={{ marginRight: 2 }} />
                        Entregado
                      </Typography>
                    )}
                    <Grid container spacing={1}>
                      <Grid item xs={12} md={tipoUsuarioArjion === "compras" ? 3 : 5}>
                        <Typography variant="body2" color="text.secondary">
                          Producto
                        </Typography>
                        <Typography variant="body2" fontWeight="medium">
                          {detalle.inventario?.nombre}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {detalle.inventario?.clave} |{" "}
                          {detalle.inventario?.ubicacion?.almacen?.nombre ??
                            "SIN ALMACÉN REGISTRADO"}
                        </Typography>
                        {detalle?.comentarios?.trim() && (
                          <Box
                            sx={{
                              pt: 0.5,
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: 0.5,
                              textAlign: "left",
                            }}
                          >
                            <IconMessage
                              size={14}
                              stroke={2}
                              color="#4a6fa5"
                              style={{ flexShrink: 0, marginTop: 2 }}
                            />
                            <Typography
                              variant="caption"
                              sx={{
                                color: "#4a6fa5",
                                fontStyle: "italic",
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                              }}
                            >
                              {detalle.comentarios}
                            </Typography>
                          </Box>
                        )}
                      </Grid>
                      <Grid item xs={6} md={1}>
                        <Typography variant="body2" color="text.secondary">
                          Cantidad
                        </Typography>
                        <Typography variant="body2" fontWeight="medium">
                          {detalle.cantidad}{" "}
                          <Typography variant="caption" fontWeight="light">
                            {detalle?.inventario?.unidad_medida?.nombre}
                          </Typography>
                        </Typography>
                      </Grid>
                      {tipoUsuarioArjion === "compras" && (
                        <Grid item xs={6} md={2}>
                          <Typography variant="body2" color="text.secondary">
                            En inventario
                          </Typography>
                          <Typography
                            variant="body2"
                            fontWeight="medium"
                            color={detalle.quedaBajoMinimo ? "error" : "inherit"}
                          >
                            {detalle?.inventario?.cantidad}
                            {detalle.yaEnMinimos && " 🔴"}
                            {detalle.quedaBajoMinimo && " ⚠️"}
                          </Typography>
                        </Grid>
                      )}
                      {tipoUsuarioArjion === "compras" && (
                        <Grid item xs={6} md={1}>
                          <Typography variant="body2" color="text.secondary">
                            Máximos
                          </Typography>
                          <Typography variant="body2" fontWeight="medium">
                            {detalle?.inventario?.maximos}
                          </Typography>
                        </Grid>
                      )}
                      {tipoUsuarioArjion === "compras" && (
                        <Grid item xs={6} md={1}>
                          <Typography variant="body2" color="text.secondary">
                            Mínimos
                          </Typography>
                          <Typography
                            variant="body2"
                            fontWeight="medium"
                            color={detalle.quedaBajoMinimo ? "error" : "inherit"}
                          >
                            {detalle?.inventario?.minimos}
                          </Typography>
                        </Grid>
                      )}
                      <Grid item xs={6} md={1}>
                        <Typography variant="body2" color="text.secondary">
                          P. Unitario
                        </Typography>
                        <Typography variant="body2" fontWeight="medium">
                          $
                          {Number(precioUnitarioMostrar).toLocaleString("es-MX", {
                            minimumFractionDigits: 2,
                          })}
                          {detalleOC && (
                            <Chip
                              label="OC"
                              size="small"
                              sx={{ ml: 0.5, height: 16, fontSize: "0.6rem" }}
                            />
                          )}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={tipoUsuarioArjion === "compras" ? 1 : 2}>
                        <Typography variant="body2" color="text.secondary">
                          Total
                        </Typography>
                        <Typography variant="body2" fontWeight="medium" sx={{ color: "#07177d" }}>
                          $
                          {Number(precioTotalMostrar).toLocaleString("es-MX", {
                            minimumFractionDigits: 2,
                          })}
                        </Typography>
                      </Grid>
                      {puedeGestionarCompras && (
                        <Grid item xs={6} md={1}>
                          <Typography variant="body2" color="text.secondary">
                            Gestionar
                          </Typography>
                          <Typography variant="body2" fontWeight="medium">
                            {detalle?.estatus !== 4 && (
                              <Tooltip title={"Marcar como entregado"}>
                                <IconButton
                                  size="small"
                                  onClick={(e: any) => {
                                    setAccionRequisicion("marcar entregado");
                                    setOpenConfirmEnviarDG(true);
                                    setNombreProducto(detalle?.inventario?.nombre);
                                    setIdProductoDetalle(detalle?.id);
                                  }}
                                >
                                  <IconTruckDelivery stroke={2} />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Typography>
                        </Grid>
                      )}
                    </Grid>
                  </Box>
                );
              })}

              {/* Total */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  mt: 1,
                  p: 1,
                  backgroundColor: "#e8f4fd",
                  borderRadius: 1,
                }}
              >
                <Typography variant="body2" fontWeight="bold" sx={{ mr: 1 }}>
                  Total de la requisición:
                </Typography>
                <Typography variant="body1" fontWeight="bold" sx={{ color: "#07177d" }}>
                  ${totalPedido.toLocaleString("es-MX", { minimumFractionDigits: 2 })}
                </Typography>
              </Box>

              {/* Paginación */}
              <TablePagination
                component="div"
                count={verRequisicion.detalles?.length ?? 0}
                page={pageProduct}
                onPageChange={handleChangePageProduct}
                rowsPerPage={rowsProductsPerPage}
                onRowsPerPageChange={handleChangeRowsProductPerPage}
                rowsPerPageOptions={[3, 5, 10]}
                labelRowsPerPage="Por página:"
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                sx={{
                  ".MuiTablePagination-toolbar": {
                    justifyContent: "space-between",
                    padding: "8px 16px",
                  },
                  ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
                    margin: 0,
                  },
                  ".MuiTablePagination-actions svg": { transform: "scaleX(-1)" },
                }}
              />
            </Paper>
          </Grid>
        )}
      </Grid>
      <ModalConfirm
        open={openConfirmEnviarDG}
        title="Confirmar acción"
        text={
          accionRequisicion === "autorizar" ? (
            <>
              ¿Desea <strong>autorizar</strong> la requisición{" "}
              <strong>{verRequisicion?.folio}</strong>?
            </>
          ) : accionRequisicion === "enviar a dg" ? (
            <>
              ¿Desea <strong>enviar</strong> la requisición <strong>{verRequisicion?.folio}</strong>{" "}
              a Dirección General?
            </>
          ) : accionRequisicion === "mandar a daf" ? (
            <>
              ¿Desea <strong>enviar</strong> la requisición <strong>{verRequisicion?.folio}</strong>{" "}
              a Dirección de Administración y Finanzas?
            </>
          ) : accionRequisicion === "rechazar" ? (
            <>
              ¿Desea <strong>rechazar</strong> la requisición{" "}
              <strong>{verRequisicion?.folio}</strong>?
            </>
          ) : accionRequisicion === "cancelar" ? (
            <>
              ¿Desea <strong>cancelar</strong> la requisición{" "}
              <strong>{verRequisicion?.folio}</strong>?
            </>
          ) : accionRequisicion === "marcar entregado" ? (
            <>
              ¿Desea <strong>marcar como entregado</strong> el producto{" "}
              <strong>{nombreProducto}</strong>?
            </>
          ) : null
        }
        onAcept={handleConfirmar}
        onCancel={() => setOpenConfirmEnviarDG(false)}
      />
    </Box>
  );
};
export default DetallesRequisicion;
